import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Bars3Icon, XMarkIcon } from "@heroicons/react/24/outline";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  const navigation = [
    { name: "Home", href: "/" },
    { name: "Courses", href: "/courses" },
    { name: "Results", href: "/results" },
     { name: "Demo", href: "/demolecture" },
    { name: "About", href: "/about" },
    // { name: "Contact", href: "/contact" },
  ];

  return (
    <nav className="bg-white/30 backdrop-blur-xl shadow-lg sticky top-0 z-50 border-b border-white/40">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-20 items-center">
          
          {/* Logo Section */}
          <Link to="/" className="flex items-center group">
            <div className="relative">
              <img
                src="ycc black.png"
                alt="Yeole Classes Logo"
                className="h-20 w-auto object-contain drop-shadow-xl transition-transform duration-300 group-hover:scale-110"
              />
            </div>

             {/* <div className="leading-tight">
              <h1 className="text-2xl sm:text-2xl font-extrabold text-gray-900 group-hover:text-blue-700 transition">
                YEOLE CLASSES
              </h1>
              <p className="text-[10px] sm:text-xs text-gray-600 tracking-wider">
                IIT-JEE • NEET • MHT-CET • 11TH • 12TH • FOUNDATION
              </p>
            </div>  */}
          </Link>

          {/* Desktop Menu */}
          <div className="hidden md:flex items-center space-x-10">
            {navigation.map((item) => (
              <Link
                key={item.name}
                to={item.href}
                className="relative text-gray-700 font-semibold transition group"
              >
                <span className="group-hover:text-blue-700 transition">
                  {item.name}
                </span>

                {/* Animated underline */}
                <span className="absolute left-0 -bottom-1 h-[3px] w-0 bg-gradient-to-r from-blue-500 to-purple-600 rounded-full transition-all duration-300 group-hover:w-full"></span>
              </Link>
            ))}

            {/* Contact Button */}
            <Link
              to="/contact"
              className="px-6 py-2 rounded-full font-semibold text-white bg-gradient-to-r from-blue-600 via-purple-600 to-pink-600 shadow-lg hover:shadow-xl hover:scale-105 transition duration-300"
            >
              Contact Us
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsOpen(!isOpen)}
            className="md:hidden text-gray-700 hover:text-blue-600 p-2 transition"
          >
            {isOpen ? <XMarkIcon className="h-7 w-7" /> : <Bars3Icon className="h-7 w-7" />}
          </button>
        </div>
      </div>

      {/* Mobile Dropdown Menu */}
      {isOpen && (
        <div className="md:hidden bg-white/95 backdrop-blur-xl border-t border-gray-200 shadow-inner animate-fadeIn">
          <div className="px-4 pt-4 pb-6 space-y-3">
            {navigation.map((item) => (
              <Link
                key={item.name}
                to={item.href}
                onClick={() => setIsOpen(false)}
                className="block px-3 py-2 text-base font-medium text-gray-700 hover:text-blue-600 hover:bg-blue-50 rounded-lg transition"
              >
                {item.name}
              </Link>
            ))}

            <Link
              to="/contact"
              onClick={() => setIsOpen(false)}
              className="block mt-4 text-center bg-gradient-to-r from-blue-600 via-purple-600 to-pink-600 text-white px-6 py-2 rounded-full font-semibold shadow-lg hover:shadow-xl hover:scale-105 transition duration-300"
            >
              Contact Us
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
